// extracted by mini-css-extract-plugin
export default {"List":"ProductList_List__dHYdn"};